var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('v-main',[_c('PageTitle',{attrs:{"title-name":"チケット購入までの流れ"}}),_c('BuyTicketProcedure',{attrs:{"userInfo":_vm.userInfo}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }